export default {
    type: 'notice',
    name: 'Advert',
    osOnly: false,
    components: {
        root: {
            name: 'ModuleNotice',
            loader: () => import('./ModuleNotice')
        }
    }
};
